
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexW_tRyo9XF2bjdk4wifhxcJPGcHoj7ElzXx4qBClbzmsMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/index.vue?macro=true";
import { default as quote1hr0Ho6sRSQ0c_Xbwqr5VbmT6kdjsR65wqmbpTotf3EMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/quote.vue?macro=true";
import { default as logsj9a50b8AYhqEI1j5_45goiKZpJ6lYMqxtROVL1uy7t9lQMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/logs.vue?macro=true";
import { default as grantxEfQcYkkyBuSFPoW8LsAP4Z1Rw_45jDgoeUBDnfZHPzdwMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/auth/grant.vue?macro=true";
import { default as loginYFSoxPxqlgap2S6iKoJLYXVwMgBABJOI9QJVEqAX3xYMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/auth/login.vue?macro=true";
import { default as indexnUX89t6fgN4U_45zTa_avbbr7c1b_450h1mv6taJgvmjFqgMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/index.vue?macro=true";
import { default as loginHXIbl_45ojSPAmqrYtFhnNztr_458wTxYEdjgPcrrtCZ9F0Meta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/login.vue?macro=true";
import { default as usersWhnGNTKMcjz5ZiiImWQ2NToHzobXOkiSEpOolfLlC3UMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/users.vue?macro=true";
import { default as rightsRJUzMWiywdTxQKVobtxEtlUH1qhCJXD_oxyA_45_45_Wb0UMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/rights.vue?macro=true";
import { default as storesnpLcpT6bwy7DUB3XwEsVxCLyZJIVPrxrUgkQ1999FTYMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/stores.vue?macro=true";
import { default as cartq85i_gC__8Vm63JZnLxcxdDvJ6Ul8Ujlpto7_457cFWXcMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/cart.vue?macro=true";
import { default as productsCToXGhLxPB2vmqFv4iL8XDyVl04CIZaEkv4KIlDFAakMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/products.vue?macro=true";
import { default as errortiobyeJod3jSiW7LPSGF2uIvbsHIhevgbLtuHzCFdKwMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/error.vue?macro=true";
import { default as infosXNmrb_458TJPM7BGdcsF_454mz88YtpMyMOlOD4A_45Zg8FsQMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/infos.vue?macro=true";
import { default as apis_45testyVQXMQmARn6f0mXfsac4Mw_453rTzFSi3guPA5jsdhKFoMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/apis-test.vue?macro=true";
import { default as countriesyr_lpIdQrPq05wHudqkPvAafEolQe4HvxGy3_45vXOf3EMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/countries.vue?macro=true";
import { default as searchcu1oRicwFQFsSry3N0NOqBUI0oPLK_4563ujcoOPPN2KsMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/search.vue?macro=true";
import { default as currenciesJQRPO00xV4CJs5uGXofVLloqnj7gPCfiOAKacYZwKDgMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/currencies.vue?macro=true";
import { default as parametersEMnicsGvoeC1miaBKbjp6jxvFO_Xt5JRtLRS8jvBtQkMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/parameters.vue?macro=true";
import { default as toolboxO8XuUzyDlh_45muhUAeTqxVp_45K0jRHSTNAXg_PeoYIzkgMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/toolbox.vue?macro=true";
import { default as contactDkipvRpT_KFvRN4YXHwbUF3_45pWCxFS21LikNu7pGVjsMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/contact.vue?macro=true";
import { default as productsxRC1JbDfxbr9a1oyAkDJhch_SV9AKJA25kJYnTn4ef0Meta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/products.vue?macro=true";
import { default as favoritesPxqjpRjDc8pnrs7Tr57CZXg2303CMYS_45ZPVbq4o3Ad0Meta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/favorites.vue?macro=true";
import { default as mapping_45rulesVA4qayyYginaaMRCfHo5tel0_45GTrKTwZdvcd_45dvBR1oMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/mapping-rules.vue?macro=true";
import { default as referentiel_45rulesqccnujsK43F75tdRtWJDMJheWaB9HC_QLz3AMFeaDZ4Meta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/referentiel-rules.vue?macro=true";
import { default as indexeTqfWSclBkY_45OWsw2oazFRZJh3S6JxfSrOrcImfkNMkMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/index.vue?macro=true";
import { default as arborescence_45referentieltegXShKww3Q_iAmBKUWQqVNU7p7cGmFebnSbWLR4RscMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/arborescence-referentiel.vue?macro=true";
import { default as index8OJVQbw1LYYaGLH_We5hQHjXcIOvmMBU_lizajft8QgMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/[category_collection]/index.vue?macro=true";
import { default as indexVeQ_MjDX6z32szLNoArWj8t_v1cxGv0ZLmBBtNkrGoEMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/[category_collection]/[model]/index.vue?macro=true";
import { default as _91product_935XxTA9ECOgyx3USCOleRcVkbkBKyxsmR2t7RItPsUSEMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/[category_collection]/[model]/[product].vue?macro=true";
import { default as _91slug_93lcmIg_45_45Xvrb6yYHr1htEysU2jfttT_Hz9APgpKe2AHkMeta } from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/[category_collection]/sous-categorie/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/index.vue")
  },
  {
    name: "quote",
    path: "/quote",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/quote.vue")
  },
  {
    name: "admin-logs",
    path: "/admin/logs",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/logs.vue")
  },
  {
    name: "auth-grant",
    path: "/auth/grant",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/auth/grant.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/auth/login.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/login.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/users.vue")
  },
  {
    name: "admin-rights",
    path: "/admin/rights",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/rights.vue")
  },
  {
    name: "admin-stores",
    path: "/admin/stores",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/stores.vue")
  },
  {
    name: "products-cart",
    path: "/products/cart",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/cart.vue")
  },
  {
    name: "admin-products",
    path: "/admin/products",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/products.vue")
  },
  {
    name: "products-error",
    path: "/products/error",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/error.vue")
  },
  {
    name: "quoteid-infos",
    path: "/:quoteid()/infos",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/infos.vue")
  },
  {
    name: "admin-apis-test",
    path: "/admin/apis-test",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/apis-test.vue")
  },
  {
    name: "admin-countries",
    path: "/admin/countries",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/countries.vue")
  },
  {
    name: "products-search",
    path: "/products/search",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/search.vue")
  },
  {
    name: "admin-currencies",
    path: "/admin/currencies",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/currencies.vue")
  },
  {
    name: "admin-parameters",
    path: "/admin/parameters",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/parameters.vue")
  },
  {
    name: "products-toolbox",
    path: "/products/toolbox",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/toolbox.vue")
  },
  {
    name: "quoteid-contact",
    path: "/:quoteid()/contact",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/contact.vue")
  },
  {
    name: "quoteid-products",
    path: "/:quoteid()/products",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/[quoteid]/products.vue")
  },
  {
    name: "products-favorites",
    path: "/products/favorites",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/favorites.vue")
  },
  {
    name: "admin-mapping-rules",
    path: "/admin/mapping-rules",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/mapping-rules.vue")
  },
  {
    name: "admin-referentiel-rules",
    path: "/admin/referentiel-rules",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/referentiel-rules.vue")
  },
  {
    name: "products-catalogue",
    path: "/products/:catalogue()",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/index.vue")
  },
  {
    name: "admin-arborescence-referentiel",
    path: "/admin/arborescence-referentiel",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/admin/arborescence-referentiel.vue")
  },
  {
    name: "products-catalogue-category_collection",
    path: "/products/:catalogue()/:category_collection()",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/[category_collection]/index.vue")
  },
  {
    name: "products-catalogue-category_collection-model",
    path: "/products/:catalogue()/:category_collection()/:model()",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/[category_collection]/[model]/index.vue")
  },
  {
    name: "products-catalogue-category_collection-model-product",
    path: "/products/:catalogue()/:category_collection()/:model()/:product()",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/[category_collection]/[model]/[product].vue")
  },
  {
    name: "products-catalogue-category_collection-sous-categorie-slug",
    path: "/products/:catalogue()/:category_collection()/sous-categorie/:slug()",
    component: () => import("/builds/hermesintl/retail/devis-maison/devis-maison-front/src/pages/products/[catalogue]/[category_collection]/sous-categorie/[slug].vue")
  }
]